module.exports = __webpack_public_path__ + "static/media/PDF.77af6c38.svg";